import React from 'react';

const NOONA_BOOKING_URL = 'https://noona.pt/yourmoment?source=SuggestedCompanyTypeScreen&rank=20';

// `glass` (dourado translúcido) foi desenhado para fundos escuros, como o vídeo
// da página inicial; sobre branco o texto branco quase desaparece. Em fundos
// claros usa-se `solid`.
const FUNDOS = {
  glass:
    'backdrop-blur-md bg-[#c0a080]/30 group-hover:bg-[#c0a080]/40 border border-white/40 group-hover:border-white/60 shadow-lg',
  solid:
    'bg-[#5c7160] group-hover:bg-[#4d5f51] border border-[#5c7160] shadow-md group-hover:shadow-lg',
};

const BookingButton = ({ className = '', children, to, fullWidth = false, variant = 'glass', ...props }) => {
  return (
    <a
      href={NOONA_BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`relative group px-6 py-3 flex items-center justify-center transition-all duration-300 transform hover:scale-105 ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {/* Fundo com efeito de vidro */}
      <span
        className={`absolute inset-0 rounded-full transition-all duration-300 ${FUNDOS[variant] || FUNDOS.glass}`}
      ></span>
      
      {/* Texto do botão */}
      <span className="relative z-10 font-medium text-white tracking-widest text-base flex items-center">
        {children || (
          <>
            <span>AGENDAR AGORA</span>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </>
        )}
      </span>
    </a>
  );
};

export default BookingButton;